import { defineComponent } from 'vue';
import { OverviewCB } from './Overview.CB';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	setup: () => {
		const codeBehind = new OverviewCB();
		return setupComponent(codeBehind);
	},
});
